import {PTA_OTHER_CATEGORIES_PATH_PATTERN, PUBLISH_MY_AD_PATH_PATTERN} from './page.js'

export const LAST_INSTANT_OFFER_DETAILS_KEY = 'lastInstantOfferDetails'
export const VEHICLE_STANDALONE_DRAFT_KEY = 'vehicleStandaloneDraftMotos'

export const IS_AI_GENERATED_COMMENTS_FEATURE_ENABLED = false
export const IS_INSTANT_OFFER_FEATURE_ENABLED = false
export const IS_PRICE_RECOMMENDER_FEATURE_ENABLED = false
export const IS_PANEL_APPRAISAL_FEATURE_ENABLED = false
export const IS_PANEL_EDITORIAL_FEATURE_ENABLED = false
export const IS_PAYMENT_AD_INFORMED_AT_PUBLISH_MY_AD_FORM = false
export const IS_VISIBILITY_PRODUCTS_DYNAMIC_PRICING_FEATURE_ENABLED = false
export const IS_VISIBILITY_PRODUCT_PACK_FEATURE_ENABLED = false

export const RECOMMENDED_NUMBER_OF_UPLOADED_IMAGES = 5

export const TOP_AD_PRODUCT_ID = `2`
export const QUICK_SALE_PRODUCT_ID = `10`
export const PACK_VISIBILITY_PRODUCT_ID = `28`

export const USER_AD_VISIBILITY_PRODUCT_CODES = {
  TOP_AD: 'TOP',
  QUICK_SALE: 'QUICK'
}

export const USER_AD_CATEGORIES = {
  MOTORCYCLE: 'MOTORCYCLE',
  QUAD: 'QUAD',
  CLASSIC_BIKE: 'CLASSIC_BIKE',
  BUGGY: 'BUGGY',
  MINIBIKE: 'MINIBIKE'
}

export const USER_AD_CATEGORY_RESOURCES = {
  [USER_AD_CATEGORIES.MOTORCYCLE]: 'motorbikes',
  [USER_AD_CATEGORIES.QUAD]: 'quads',
  [USER_AD_CATEGORIES.CLASSIC_BIKE]: 'classicbikes',
  [USER_AD_CATEGORIES.BUGGY]: 'buggies',
  [USER_AD_CATEGORIES.MINIBIKE]: 'minibikes'
}

export const DEFAULT_USER_AD_CATEGORY = USER_AD_CATEGORIES.MOTORCYCLE

export const USER_AD_CATEGORIES_WITH_DRAFT = [USER_AD_CATEGORIES.MOTORCYCLE]

export const USER_AD_CATEGORIES_WITH_INSTANT_OFFER = [USER_AD_CATEGORIES.MOTORCYCLE]

export const USER_AD_CATEGORIES_WITH_CONTENT_SHARING = []

export const USER_AD_CATEGORIES_WITH_REQUIRED_LOGIN = [
  USER_AD_CATEGORIES.QUAD,
  USER_AD_CATEGORIES.CLASSIC_BIKE,
  USER_AD_CATEGORIES.BUGGY,
  USER_AD_CATEGORIES.MINIBIKE
]

export const EDIT_MY_AD_OTHER_CATEGORIES = [USER_AD_CATEGORIES.QUAD, USER_AD_CATEGORIES.BUGGY]

export const SEMANTIC_SELLER_LOCATIONS_MAPPING = {
  madrid: {slug: 'madrid', label: 'Madrid'},
  barcelona: {slug: 'barcelona', label: 'Barcelona'},
  zaragoza: {slug: 'zaragoza', label: 'Zaragoza'},
  valencia: {slug: 'valencia', label: 'Valencia'},
  sevilla: {slug: 'sevilla', label: 'Sevilla'},
  malaga: {slug: 'malaga', label: 'Málaga'},
  murcia: {slug: 'murcia', label: 'Murcia'},
  ciudadReal: {slug: 'ciudad-real', label: 'Ciudad Real'},
  cornella: {slug: 'cornella', label: 'Cornellà'},
  mallorca: {slug: 'mallorca', label: 'Mallorca'},
  vigo: {slug: 'vigo', label: 'Vigo'},
  albacete: {slug: 'albacete', label: 'Albacete'},
  tenerife: {slug: 'tenerife', label: 'Tenerife'},
  lasPalmas: {slug: 'las-palmas', label: 'Las Palmas'},
  jerez: {slug: 'jerez', label: 'Jerez'},
  cordoba: {slug: 'cordoba', label: 'Córdoba'},
  santander: {slug: 'santander', label: 'Santander'},
  asturias: {slug: 'asturias', label: 'Asturias'}
}

export const BENEFITS_CARDS_TABS = {
  BENEFITS_OF_SELLING_TO_PROFESSIONAL: 1,
  BENEFITS_OF_SELLING_TO_PRIVATE: 2
}

export const VEHICLE_CATEGORIES = [
  {
    image: `vehicles/motorbike@2x.png`,
    title: `PUBLISH_AD.VEHICLE_CATEGORIES.MOTORCYCLE`,
    url: `${PUBLISH_MY_AD_PATH_PATTERN}`
  },
  {
    image: `vehicles/classic@2x.png`,
    title: `PUBLISH_AD.VEHICLE_CATEGORIES.CLASSIC_BIKE`,
    url: `${PUBLISH_MY_AD_PATH_PATTERN}?category=${USER_AD_CATEGORY_RESOURCES[USER_AD_CATEGORIES.CLASSIC_BIKE]}`
  },
  {
    image: `vehicles/quad@2x.png`,
    title: `PUBLISH_AD.VEHICLE_CATEGORIES.QUAD`,
    url: `${PTA_OTHER_CATEGORIES_PATH_PATTERN}?section=quads`
  },
  {
    image: `vehicles/buggy@2x.png`,
    title: `PUBLISH_AD.VEHICLE_CATEGORIES.BUGGY`,
    url: `${PTA_OTHER_CATEGORIES_PATH_PATTERN}?section=buggy`
  },
  {
    image: `vehicles/minibike@2x.png`,
    title: `PUBLISH_AD.VEHICLE_CATEGORIES.MINIBIKE`,
    url: `${PUBLISH_MY_AD_PATH_PATTERN}?category=${USER_AD_CATEGORY_RESOURCES[USER_AD_CATEGORIES.MINIBIKE]}`
  },
  {
    categoryTitle: `PUBLISH_AD.MILANUNCIOS_AVAILABLE_TITLE`,
    categoryTitleImage: `common/logos/milanuncios-logomark.svg`,
    image: `vehicles/moto-wheel@2x.png`,
    title: `COMMON.PLURALS.ACCESSORY`,
    url: `https://www.milanuncios.com/publicar-anuncios-gratis/publicar?c=26`
  }
]

export const VEHICLE_CATEGORIES_ASIDE_ILLUSTRATION = `illustrations/motos-categories.svg`
